import React, { useState, useRef, useEffect } from "react";
import './Dropdown.scss';
import { useNavigate } from "react-router-dom";

const Dropdown = ({ label = "Select", items = [] }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  const toggleDropdown = () => setIsOpen(prev => !prev);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleItemClick = (item) => {
    if (item.onClick) {
      item.onClick();
    } else if (item.href) {
      navigate(item.href);
    }
    setIsOpen(false);
  };

  return (
    <div className="dropdowncontainer" ref={dropdownRef}>
      <button onClick={toggleDropdown} className="dropdownbutton">
        {label}
      </button>

      {isOpen && (
        <div className="dropdowninner">
          <div className="py-1">
            {items.map((item, index) => (
              <div
                key={index}
                className="dropdown-item"
                onClick={() => handleItemClick(item)}
              >
                {item.label}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Dropdown;